import { render, staticRenderFns } from "./FullPreview.vue?vue&type=template&id=634e00dd&scoped=true&"
import script from "./FullPreview.vue?vue&type=script&lang=js&"
export * from "./FullPreview.vue?vue&type=script&lang=js&"
import style0 from "./FullPreview.vue?vue&type=style&index=0&id=634e00dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634e00dd",
  null
  
)

export default component.exports